import axios from 'axios'
import { GET_MERCHANTS_FOR_EMPLOYEE_URL } from './consts'

export interface IMerchantOption {
  id: number
  token: string
  title: string
}

interface IMerchantsForSelectRes {
  success: boolean
  merchants: IMerchantOption[]
  totalRows: number
}

export const getMerchantsForSelect = () => {
  return axios.get<IMerchantsForSelectRes>(GET_MERCHANTS_FOR_EMPLOYEE_URL, {
    params: {
      perPage: 99,
      page: 1,
      enabled: true,
    },
  })
}
